import { formatAppDate } from "../../app/utils/appTimeFormat";

export function parseMongoDate(value) {
  if (!value) return null;
  let raw = value;
  if (typeof raw === "object" && raw.$date) raw = raw.$date;
  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatMemberSince(value) {
  const date = parseMongoDate(value);
  if (!date) return "—";
  return formatAppDate(date, { includeWeekday: false });
}

export function formatMemberSinceShort(value) {
  const date = parseMongoDate(value);
  if (!date) return "—";
  return formatAppDate(date, { includeWeekday: false });
}
